var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.$store.state.schedule.loadingSchedule)?_c('jcdc-loading-page'):_c('div',[_c('jcdc-calendar',{key:_vm.loadingSchedule,attrs:{"display":"week","holiday-us":"","events":_vm.studentSchedule,"hide-navigation":"","weekdays":_vm.mobile ? [1, 2, 3, 4, 5] : [0, 1, 2, 3, 4, 5, 6]}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }